import { Label, LabelColor } from '@shared/components';

export type ExamLocationRequestStatusLabelVariant = 'draft' | 'in-review' | 'rejected';

interface ExamLocationRequestStatusLabelProps {
  variant: ExamLocationRequestStatusLabelVariant;
}

const EXAM_LOCATION_REQUEST_STATUS_COLOR: Readonly<
  Record<ExamLocationRequestStatusLabelVariant, LabelColor>
> = {
  draft: LabelColor.INFO,
  'in-review': LabelColor.WARNING,
  rejected: LabelColor.ERROR,
};

const EXAM_LOCATION_REQUEST_STATUS_TEXT: Readonly<
  Record<ExamLocationRequestStatusLabelVariant, string>
> = {
  draft: 'แบบร่าง',
  'in-review': 'อยู่ระหว่างอนุมัติ',
  rejected: 'ไม่อนุมัติ',
};

export default function ExamLocationRequestStatusLabel(
  props: Readonly<ExamLocationRequestStatusLabelProps>,
) {
  const { variant } = props;

  return (
    <Label
      sx={{ px: (theme) => theme.spacing(3) }}
      color={EXAM_LOCATION_REQUEST_STATUS_COLOR[variant]}
      variant='outlined'
    >
      {EXAM_LOCATION_REQUEST_STATUS_TEXT[variant]}
    </Label>
  );
}
